import * as React from "react"
import type { SVGProps } from "react"
const SvgView = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 16.57q1.87 0 3.19-1.31c1.32-1.31 1.31-1.94 1.31-3.19q0-1.87-1.31-3.19C13.88 7.56 13.25 7.57 12 7.57q-1.87 0-3.19 1.31C7.5 10.2 7.5 10.82 7.5 12.07q0 1.87 1.31 3.19c1.31 1.32 1.94 1.31 3.19 1.31m0-1.8a2.6 2.6 0 0 1-1.91-.79 2.6 2.6 0 0 1-.79-1.91q0-1.13.79-1.91A2.6 2.6 0 0 1 12 9.37q1.13 0 1.91.79.8.78.79 1.91c-.01 1.13-.26 1.39-.79 1.91a2.6 2.6 0 0 1-1.91.79m0 4.8q-3.35 0-6.11-1.8a13 13 0 0 1-4.36-4.75 2 2 0 0 1-.2-1.44 2 2 0 0 1 .2-.46 13 13 0 0 1 4.36-4.75q2.76-1.8 6.11-1.8t6.11 1.8 4.37 4.75a2 2 0 0 1 .18 1.44 2 2 0 0 1-.18.46 13 13 0 0 1-4.37 4.75 11 11 0 0 1-6.11 1.8m0-2a9.5 9.5 0 0 0 5.19-1.49 10 10 0 0 0 3.61-4.01 10 10 0 0 0-3.61-4.01A9.6 9.6 0 0 0 12 6.57a9.6 9.6 0 0 0-5.19 1.49 10 10 0 0 0-3.61 4.01 10 10 0 0 0 3.61 4.01A9.5 9.5 0 0 0 12 17.57" />
  </svg>
)
export default SvgView
